/**
 * The one place the app builds a link to a maps app. The pickup panel, on
 * the call and on the assigned-call prompt, opens Google Maps or Apple Maps
 * on the place.
 */

/** A place on a call: its address, and its pin when the call has one. */
export interface MapPlace {
  address: string;
  lat?: number | null;
  lng?: number | null;
}

/** The pin when there is one, else the address. 0,0 is what a failed fix sends. */
const query = ({ address, lat, lng }: MapPlace): string =>
  lat && lng ? `${lat},${lng}` : address;

/** The place in Google Maps: the app on a phone that has it, else the site. */
export const googleMapsUrl = (place: MapPlace): string =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query(place))}`;

/** The place in Apple Maps, which an iPhone opens in its Maps app. */
export const appleMapsUrl = (place: MapPlace): string =>
  `https://maps.apple.com/?q=${encodeURIComponent(query(place))}`;
